import $ from 'jquery';
import btmq from './Plugins/BootstrapMediaQuery';
import ifExists from './Plugins/ifExists';

function new_map($el) {
    // var
    var $markers = $el.find('.marker');
    // vars
    var args = {
        zoom: 16,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    // create map
    var map = new google.maps.Map($el[0], args);
    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function() {

        add_marker($(this), map);

    });

    // center map
    center_map(map);

    // return
    return map;

}


function add_marker($marker, map) {

    // var
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

    // create marker
    var marker = new google.maps.Marker({
        position: latlng,
        map: map
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
        // create info window
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function() {

            infowindow.open(map, marker);

        });
    }

}


function center_map(map) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function(i, marker) {

        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

        bounds.extend(latlng);

    });

    // only 1 marker?
    if (map.markers.length == 1) {
        // set center of map
        map.setCenter(bounds.getCenter());
        map.setZoom(16);
    } else {
        // fit to bounds
        map.fitBounds(bounds);
    }

}

var map = null;
$(function () {
	// Document ready
    var jumboheight = $('.jumbotron').height() / 2;
    $(".panel-toggle, .jumbotron .gform_title").click(function () {
      if ($('.panel').hasClass('active') ) {
        $('.panel').animate({height:90},200);
        $('.panel').removeClass('active');
      } else {
        $('.panel').animate({height:jumboheight},200);
        $('.panel').addClass('active');
      }
    });



    $('.acf-map').each(function() {
        map = new_map($(this));
    });

    $('.excerpt, .calendar .ml-4').matchHeight({ property: 'min-height' });
    $('.article-title').matchHeight({ property: 'min-height' });
    $('.cform').matchHeight({ property: 'min-height' });
    //$('.date').matchHeight({ property: 'height' });

    $('#photos a').simpleLightbox();
    $('.gallery-icon a').simpleLightbox();

    $(window).scroll(function() {
      if ($(this).scrollTop() > 180){
        $('nav').addClass("sticky");
      }
      else {
        $('nav').removeClass("sticky");
      }
    });

    $('.medewerkers').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
    });

    $('.single-medewerker-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3200,
        arrows: true,
        focusOnSelect: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
    });

    $('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
    });

    $('.calendar').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
    });

    var $srcSets = $('.srcSet');

    $srcSets.each(function() {
        var $currImg = $(this);
        var img = $currImg.get(0);
        var src = img.currentSrc ? img.currentSrc : img.src;
        $currImg.closest('.bgFromSrcSet').css('background-image', "url('" + src + "')").animate({
            opacity: 1
        }, {
            duration: 1000
        });
        $srcSets = $srcSets.not($currImg);
        $currImg.remove();
    });

    var changeTimer = false;
    $('.diensten-filter input').on('change',function(){
        if(changeTimer !== false) clearTimeout(changeTimer);
        changeTimer = setTimeout(function(){
            $.ajax({
                url: ajax_obj.ajaxurl,
                data: {
                    'action': 'dienstfilter',
                    'data' : $('.diensten-filter').serializeArray(),
                    'security' : ajax_obj.ajax_nonce
                },
                success:function(data) {
                    $('.diensten-container').html(data);
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });
            changeTimer = false;
        },300);
    });

    $('.newsfilter input, .newsfilter .list-group-item').on('change',function(){
        if(changeTimer !== false) clearTimeout(changeTimer);
        changeTimer = setTimeout(function(){
            $('.result').fadeOut();
            $.ajax({
                url: ajax_obj.ajaxurl,
                data: {
                    'action': 'nieuwsfilter',
                    'data' : $('.newsfilter form').serializeArray(),
                    'security' : ajax_obj.ajax_nonce
                },
                success:function(data) {
                    $('.result').html(data).fadeIn();
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });
            changeTimer = false;
        },300);
    });

    $('.event-filter input').on('change',function(){
        if(changeTimer !== false) clearTimeout(changeTimer);
        changeTimer = setTimeout(function(){
            $.ajax({
                url: ajax_obj.ajaxurl,
                data: {
                    'action': 'eventfilter',
                    'data' : $('.event-filter').serializeArray(),
                    'security' : ajax_obj.ajax_nonce
                },
                success:function(data) {
                    $('.event-list').html(data);
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });
            changeTimer = false;
        },300);
    });

    $('.checkbox-list-group input').on('change',function(){
        if( $(this).prop( "checked" ) == true ){
            $(this).closest('.list-group-item').addClass('active');
        }
        else {
            $(this).closest('.list-group-item').removeClass('active');
        }
    });

    $('a[href="#search"]').on('click', function(event) {
        event.preventDefault();
        $('#search').addClass('open');
        $('#search > form > input[type="search"]').focus();
    });

    $('#search, #search button.close').on('click keyup', function(event) {
        if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
            $(this).removeClass('open');
        }
    });

    $('.loading').bind('ajaxStart', function(){
        $(this).show();
    }).bind('ajaxStop', function(){
        $(this).hide();
    });

    $('.filter-toggle').click(function(e) {
        e.preventDefault();
        $( "#filter-panel" ).toggleClass( 'd-none' );
    });

});
